// extracted by mini-css-extract-plugin
export default {"basicInfoTitle":"_1jt59na","iconWrapper":"_mhqr40"};